export function getFrames (key, n, start = 0) {
  const frames = []
  for (let i = start; i < n + start; i += 1) {
    frames.push(`${key}${i}`)
  }
  return frames
}

export function copyFrames (frames, times = 1) {
  let copyFrames = []
  for (let i = 0; i < times; i += 1) {
    copyFrames = copyFrames.concat(frames)
  }
  return copyFrames
}



// WEBPACK FOOTER //
// ./src/utils.js